/**
 * Utility function to construct proper image URLs
 * @param {string} imageValue - The image value (could be filename or full URL)
 * @returns {string} - The complete image URL
 */
export const getImageUrl = (imageValue) => {
  if (!imageValue) return '';

  // If it's already a full URL, return as-is
  if (imageValue.startsWith('http')) {
    return imageValue;
  }

  // Use local backend in development, production domain otherwise
  if (process.env.NODE_ENV === 'development') {
    return `https://fitenggmeerut.com/api/uploads/serve/images/${imageValue}`;
  } else {
    const productionDomain = process.env.REACT_APP_API_URL?.replace('/api', '') || 'https://fitenggmeerut.com';
    return `${productionDomain}/api/uploads/serve/images/${imageValue}`;
  }
};

/**
 * Get direct image URL for admin previews (bypasses proxy for immediate preview)
 * @param {string} imageValue - The image filename
 * @returns {string} - Direct backend URL for admin previews
 */
export const getAdminImageUrl = (imageValue) => {
  if (!imageValue) return '';

  // If it's already a full URL, return as-is
  if (imageValue.startsWith('http')) {
    return imageValue;
  }

  // For admin previews, use local backend in development
  if (process.env.NODE_ENV === 'development') {
    return `https://fitenggmeerut.com/api/uploads/serve/images/${imageValue}`;
  } else {
    const productionDomain = process.env.REACT_APP_API_URL?.replace('/api', '') || 'https://fitenggmeerut.com';
    return `${productionDomain}/api/uploads/serve/images/${imageValue}`;
  }
};

/**
 * Utility function for inline styles that require url() wrapper
 * @param {string} imageValue - The image value (could be filename or full URL)
 * @returns {string} - The complete image URL wrapped in url()
 */
export const getImageUrlForStyle = (imageValue) => {
  const url = getImageUrl(imageValue);
  return url ? `url(${url})` : '';
};